import { render } from "./ArchiveBlocksSection.vue?vue&type=template&id=6d027e74&scoped=true"
import script from "./ArchiveBlocksSection.vue?vue&type=script&lang=js"
export * from "./ArchiveBlocksSection.vue?vue&type=script&lang=js"

import "./ArchiveBlocksSection.vue?vue&type=style&index=0&id=6d027e74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d027e74"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QIcon,QItem});
